import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const PieChartWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function PieChartWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M14.7444 14.1251H2.87439C2.7923 14.1252 2.711 14.109 2.63515 14.0776C2.55929 14.0463 2.49036 14.0002 2.4323 13.9422C2.37423 13.8841 2.32817 13.8152 2.29675 13.7394C2.26532 13.6635 2.24914 13.5822 2.24914 13.5001C2.24926 10.1849 3.56576 7.0055 5.90905 4.66131C8.25235 2.31712 11.4305 1.00012 14.7444 1C14.9101 1 15.0691 1.06585 15.1862 1.18307C15.3034 1.30029 15.3692 1.45927 15.3692 1.62505V13.4996C15.3693 13.5817 15.3532 13.6631 15.3218 13.7389C15.2904 13.8148 15.2444 13.8838 15.1864 13.9419C15.1284 14 15.0595 14.046 14.9836 14.0775C14.9078 14.1089 14.8265 14.1251 14.7444 14.1251Z"
        fill="#6C4FC2"
      />
      <path
        d="M1.62488 15.3751H13.4949C13.6172 15.3768 13.7362 15.4144 13.8374 15.4831C13.9385 15.5518 14.0172 15.6488 14.0639 15.7618C14.1105 15.8749 14.1229 15.9992 14.0996 16.1192C14.0763 16.2393 14.0183 16.3499 13.9328 16.4373L5.53547 24.8378C5.47772 24.8961 5.40906 24.9423 5.33343 24.974C5.25779 25.0057 5.17665 25.0222 5.09465 25.0225C5.01265 25.0229 4.93138 25.007 4.8555 24.9759C4.77961 24.9448 4.7106 24.8991 4.65239 24.8413L4.64848 24.8378C3.48702 23.6788 2.56661 22.301 1.9404 20.7842C1.31419 19.2673 0.994597 17.6413 1.00007 16.0002C1.00007 15.8344 1.0659 15.6754 1.18307 15.5582C1.30024 15.441 1.45917 15.3751 1.62488 15.3751Z"
        fill="#EF145D"
      />
      <path
        d="M16.6182 15.7375V4.12519C16.6182 4.04313 16.6344 3.96187 16.6658 3.88606C16.6972 3.81025 16.7432 3.74137 16.8013 3.68337C16.8593 3.62536 16.9282 3.57936 17.004 3.548C17.0798 3.51663 17.161 3.50052 17.243 3.50058C19.5435 3.49848 21.8077 4.07407 23.8281 5.17458C25.8485 6.27509 27.5605 7.86532 28.8071 9.79951C30.0537 11.7337 30.7951 13.95 30.9632 16.2452C31.1314 18.5404 30.721 20.8411 29.7696 22.9364C28.8183 25.0318 27.3564 26.8547 25.518 28.2382C23.6796 29.6217 21.5235 30.5214 19.2473 30.8549C16.9711 31.1884 14.6476 30.945 12.4898 30.147C10.3321 29.349 8.40901 28.022 6.89697 26.2876C6.78986 26.172 6.73034 26.0202 6.73034 25.8626C6.73034 25.705 6.78986 25.5532 6.89697 25.4377L16.6182 15.7375Z"
        fill="#CFC5F0"
      />
    </SvgStyled>
  );
});
